import React from "react";
import PropTypes from "prop-types";
import Form from "../Form/form";
import {controlPropTypes} from "../formhelpers";

class GridCell extends React.Component {
    render() {
        const {
            descriptor
        } = this.props;
        const config = descriptor.config || {};
        const selector = `control-container-${descriptor.key}`;

        const className = [selector, "control-layout-gridcell"];
        if(config.controlOnly) {
            className.push("control-only");
        }
        switch(config.align) {
            case "right":
                className.push("text-right");
                break;
            case "center":
                className.push("text-center");
                break;
            case "left":
            default:
                className.push("text-left");
        }

        const CellType = config.heading ? (<th />) : (<td />);

        return (
            <CellType
                id={descriptor.id}
                className={className}
            >
                <Form {...this.props} controlOnly={config.controlOnly} />
            </CellType>
        );
    }
}

GridCell.defaultProps = {
    descriptor: {
        config: {
            controlOnly: true,
            heading: false,
            align: "left"
        }
    },
    controlOnly: true,
    placeholder: true
};

GridCell.propTypes = {
    ...controlPropTypes({
        controlOnly: PropTypes.bool,
        heading: PropTypes.bool,
        align: PropTypes.oneOf(["left", "right", "center"])
    }, false, false),
    propsResolver: PropTypes.func.isRequired,
    onCommitChange: PropTypes.func, // not required
};

export default GridCell;



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/Layout/gridcell.js